import * as t from 'ts-codec';
import { date, ObjectId, Resource } from '@journeyapps-labs/micro-codecs';
import { string } from 'ts-codec';
export var NotificationType;
(function (NotificationType) {
    NotificationType["ANNOUNCEMENT"] = "announcement";
    NotificationType["PACK_INVITATION"] = "pack-invitation";
    NotificationType["PACK_JOIN_REQUEST"] = "pack-join-request";
    NotificationType["GROUP_INVITATION"] = "group-invitation";
})(NotificationType || (NotificationType = {}));
export const SharedNotificationFields = Resource.and(t.object({
    seen_at: date.optional(),
    profile_id: ObjectId,
    text: string
}));
export const GroupInviteNotification = SharedNotificationFields.and(t.object({
    type: t.literal(NotificationType.GROUP_INVITATION),
    group_id: ObjectId,
    invite_id: ObjectId
}));
export const PackInviteNotification = SharedNotificationFields.and(t.object({
    type: t.literal(NotificationType.PACK_INVITATION),
    pack_id: ObjectId,
    invite_id: ObjectId
}));
export const PackJoinRequestNotification = SharedNotificationFields.and(t.object({
    type: t.literal(NotificationType.PACK_JOIN_REQUEST),
    pack_id: ObjectId,
    invite_id: ObjectId
}));
export const AnnouncementNotification = SharedNotificationFields.and(t.object({
    type: t.literal(NotificationType.ANNOUNCEMENT)
}));
export const UserNotification = PackInviteNotification.or(AnnouncementNotification)
    .or(GroupInviteNotification)
    .or(PackJoinRequestNotification);
